(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["we-site-retouren-formular"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRetourenForm(root) {
      if (!root || root.dataset.retourenReady === 'true') return;
      root.dataset.retourenReady = 'true';

      const tabs = root.querySelectorAll('[data-mode]');
      const heading = root.querySelector('[data-retouren-heading]');
      const reasonField = root.querySelector('[data-retouren-reason-field]');
      const reasonLabel = root.querySelector('[data-retouren-reason-label]');
      const reasonSelect = root.querySelector('[data-retouren-reason-select]');
      const mhdField = root.querySelector('[data-retouren-mhd-field]');
      const mhdInput = root.querySelector('[data-retouren-mhd-input]');
      const typeInput = root.querySelector('[data-retouren-type]');
      const message = root.querySelector('[data-retouren-message]');
      const submitLabel = root.querySelector('[data-retouren-submit-label]');

      function setMode(mode) {
        const isRetoure = mode !== 'reklamation';

        tabs.forEach(function (tab) {
          const active = tab.dataset.mode === mode;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (heading) {
          heading.textContent = isRetoure
            ? root.dataset.headingRetoure
            : root.dataset.headingReklamation;
        }

        if (reasonLabel) {
          const labelText = isRetoure
            ? root.dataset.reasonLabelRetoure
            : root.dataset.reasonLabelReklamation;
          reasonLabel.replaceChildren();
          reasonLabel.appendChild(document.createTextNode(labelText + ' '));
          const star = document.createElement('span');
          star.className = 'we-site-retouren-formular__required';
          star.setAttribute('aria-hidden', 'true');
          star.textContent = '*';
          reasonLabel.appendChild(star);
        }

        if (reasonField) {
          reasonField.classList.toggle(
            'we-site-retouren-formular__field--full',
            isRetoure
          );
        }

        if (mhdField) {
          mhdField.hidden = isRetoure;
        }

        if (mhdInput) {
          mhdInput.disabled = isRetoure;
          mhdInput.required = !isRetoure;
          if (isRetoure) mhdInput.value = '';
        }

        if (typeInput) {
          typeInput.value = isRetoure
            ? root.dataset.typeRetoure
            : root.dataset.typeReklamation;
        }

        if (message) {
          message.placeholder = isRetoure
            ? root.dataset.placeholderRetoure
            : root.dataset.placeholderReklamation;
        }

        if (submitLabel) {
          submitLabel.textContent = isRetoure
            ? root.dataset.buttonRetoure
            : root.dataset.buttonReklamation;
        }

        if (reasonSelect) {
          const template = root.querySelector(
            '[data-retouren-reason-template="' + mode + '"]'
          );
          if (template) {
            reasonSelect.innerHTML = template.innerHTML;
          }
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          setMode(tab.dataset.mode);
        });
      });
    }

    function initAll() {
      document
        .querySelectorAll('.we-site-retouren-formular[data-section-id]')
        .forEach(initRetourenForm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.querySelector
        ? event.target.querySelector('.we-site-retouren-formular')
        : null;
      if (section) initRetourenForm(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
